import { toast } from 'react-toastify';
import i18n from '../i18n/i18n';

/**
 * Centralized function to handle PWA installation or desktop app download
 * This function can be used across all components that need download functionality
 */
export const downloadDesktopApp = () => {
  // Check if PWA is supported
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    // PWA installation prompt
    const installPrompt = window.deferredPrompt;
    if (installPrompt) {
      installPrompt.prompt();
      installPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          toast.success(i18n.t('desktopApp.toast.installed'));
        } else {
          toast.info(i18n.t('desktopApp.toast.installCancelled'));
        }
        window.deferredPrompt = null;
      });
    } else {
      // PWA already installed or not available
      toast.info(i18n.t('desktopApp.toast.alreadyInstalled'));
      // Fallback: navigate to app store or download page
      window.open('https://coursolo.ai/download', '_blank');
    }
  } else {
    // Fallback for non-PWA browsers
    toast.info(i18n.t('desktopApp.toast.openingDownload'));
    window.open('https://coursolo.ai/download', '_blank');
  }
};

/**
 * Check if PWA is installed
 */
export const isPWAInstalled = () => {
  return window.matchMedia('(display-mode: standalone)').matches || 
         window.navigator.standalone === true;
};

/**
 * Check if PWA installation is available
 */
export const isPWAInstallAvailable = () => {
  return 'serviceWorker' in navigator && 
         'PushManager' in window && 
         window.deferredPrompt !== undefined;
};
